<div class="border">
    <div class="row">
        <div class="col-sm-3">
            <!-- <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>TipoDerechoDePaso <span class="required">*</span></mat-label>
                <input matInput formControlName="TipoDerechoDePaso">
            </mat-form-field>
            <div *ngIf="FormTransporte.controls.TipoDerechoDePaso.invalid && FormTransporte.controls.TipoDerechoDePaso.touched">
                <div *ngIf="FormTransporte.controls.TipoDerechoDePaso.errors.required" style="font-size: 12px;color: red;">El campo es requerido.</div>
            </div> -->
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>TipoDerechoDePaso </mat-label>
                <input matInput aria-label="State" matInput formControlName="TipoDerechoDePaso" [matAutocomplete]="autoTipoDerechoPaso">
                <span class="text-danger"
                    *ngIf="FormTransporte.controls.TipoDerechoDePaso.invalid && FormTransporte.controls.TipoDerechoDePaso.touched">
                    Campo requerido
                </span>
                <mat-autocomplete #autoTipoDerechoPaso="matAutocomplete" [displayWith]="displayTipoDerechoPaso">
                    <mat-option *ngFor="let item of opcionesTipoDerechoPaso| async" [value]="item.id"
                        style="height: 35px;">
                        <span> {{item.attributes?.clave}} - {{item.attributes?.derechoPaso}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    
        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>KilometrajePagado <span class="required">*</span></mat-label>
                <input matInput type="number" formControlName="KilometrajePagado">
            </mat-form-field>
            <div *ngIf="FormTransporte.controls.KilometrajePagado.invalid && FormTransporte.controls.KilometrajePagado.touched">
                <div *ngIf="FormTransporte.controls.KilometrajePagado.errors.required" style="font-size: 12px;color: red;">El campo es requerido.</div>
            </div>  
        </div>
    </div>
</div>